import React, { useState, useEffect } from "react";
import Banner from "../common/Banner";
import "./home.css";

import { Modal, Button } from "react-bootstrap";

import { Link, useNavigate } from "react-router-dom";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import BlogsService from "../Services/blogs.service";
import ContactService from "../Services/contact.service";

import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

import Aviation from "../assets/images/avition.png";
import Healthcare from "../assets/images/healthcare.png";
import Logistics from "../assets/images/logistics.png";
import Retail from "../assets/images/retail.png";
import Construction from "../assets/images/construction.png";

import LMS from "../assets/images/lms.png";
import Examiner from "../assets/images/examiner.png";
import CCD from "../assets/images/customer-course-development.png";

import { UilAngleRight } from "@iconscout/react-unicons";

import { domainData } from "../Data/data";

import { Form } from "react-bootstrap";

import Anim1 from "../assets/images/airplane-unscreen.gif";
import Anim2 from "../assets/images/heartbeat-unscreen.gif";
import Anim3 from "../assets/images/boat-unscreen.gif";
import Anim4 from "../assets/images/shopping-cart-unscreen.gif";
import Anim5 from "../assets/images/crane-unscreen.gif";

import AOS from "aos";
import "aos/dist/aos.css";


const Home = () => {
  const navigate = useNavigate();
  const [blogs, setBlogs] = useState([]);
  const [show2, setShow2] = useState(false);

  const [validated, setValidated] = useState(false);
  const [userDetails, setUserDetails] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      toast("*Please fill all required fields!", {
        // position: "top-center",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      return;
    }

    if (validated) {
      ContactService.submitContactUsData(userDetails)
        .then((response) => {
          // console.log(reaponse.data)
          if (response.data === true) {
            handleShow2();
          }
        })
        .catch((error) => {
          console.error("There was a problem with the fetch operation:", error);
        });
    }
    setValidated(true);
    event.preventDefault();
  };

  useEffect(() => {
    AOS.init();
  }, []);


  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const required = (value) => {
    if (!value) {
      return (
        <div className="alert alert-danger" role="alert">
          This field is required!
        </div>
      );
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setUserDetails({ ...userDetails, [name]: value });
  };

  const handleShow2 = () => setShow2(true);
  const handleClose2 = () => setShow2(false);

  const fetchBlogs = () => {
    BlogsService.fetchBlogsData()
      .then((response) => {
        if (response.data) {
          // console.log(response.data);
          const latestBlogs = response.data.slice(-4);
          setBlogs(latestBlogs);
        } else {
          console.error("No blog found with the specified id");
        }
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
      });
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  const options = {
    margin: 30,
    responsiveClass: true,
    nav: false,
    dots: false,
    autoplay: true,
    navText: ["Prev", "Next"],
    smartSpeed: 1000,
    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 1,
      },
      600: {
        items: 1,
      },
      1024: {
        items: 1.5,
      },
      1280: {
        items: 2.5,
      },
      1366: {
        items: 2.75,
      },
    },
  };

  const handleBlogClick = (item) => {
    navigate("/Blog", { state: { blogId: item.id } });
  };

  return (
    <>
      <Banner />
      <div className="after-banner">
        <div className="after-banner-circle"></div>
        <div className="section domains" id="domains" 
        >
          <div className="heading" data-aos="fade-up" data-aos-duration="3000">
            <h2>Domains</h2>
            <p>
              Harbor tailored learning experience for every level with
              personalized, accessible, and flexible online learning.
            </p>
          </div>
          <div className="" data-aos="fade-up" data-aos-duration="3000">
          <OwlCarousel className="owl-theme" {...options}>
            <div className="domain">
              <div className="domain-img">
                <img src={Aviation} alt="" />
              </div>
              <div className="domain-content">
                <div className="sub-heading">
                  <h3>Aviation</h3>
                  <img src={Anim1} className="anim-imgs" alt="" />
                </div>
                <div className="para">
                  <p>
                    With years of experience in the Aviation industry, Fidus has
                    been providing comprehensive aviation training with courses
                    tailored to the specific needs of pilots, ground staff, and
                    other aviation professionals.
                  </p>
                </div>
                <div className="action">
                  <Link to={"/aviation"}>
                    Read More
                    <div class="arrow">
                      <span></span>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
            <div className="domain">
              <div className="domain-img">
                <img src={Healthcare} alt="" />
              </div>
              <div className="domain-content">
                <div className="sub-heading">
                  <h3>Health Care</h3>
                  <img src={Anim2} className="anim-imgs" alt="" />
                </div>
                <div className="para">
                  <p>
                    In the constantly changing landscape of healthcare, it's
                    vital for professionals to remain current with the latest
                    protocols and advancements. Conventional training approaches
                    often prove cumbersome and time-intensive, resulting in gaps
                    in knowledge that can impede patient care..
                  </p>
                </div>
                <div className="action">
                  <Link to={"/healthcare"}>
                    Read More
                    <div class="arrow">
                      <span></span>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
            <div className="domain">
              <div className="domain-img">
                <img src={Logistics} alt="" />
              </div>
              <div className="domain-content">
                <div className="sub-heading">
                  <h3>Logistics</h3>
                  <img src={Anim3} className="anim-imgs" alt="" />
                </div>
                <div className="para">
                  <p>
                    In an industry where every moment counts and safety is of
                    utmost importance, staying ahead of the competition is
                    essential. Our custom eTraining solutions are meticulously
                    crafted to address the distinct challenges and needs of the
                    transportation and logistics sector
                  </p>
                </div>
                <div className="action">
                  <Link to={"/logistics"}>
                    Read More{" "}
                    <div class="arrow">
                      <span></span>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
            <div className="domain">
              <div className="domain-img">
                <img src={Retail} alt="" />
              </div>
              <div className="domain-content">
                <div className="sub-heading">
                  <h3>Retail</h3>
                  <img src={Anim4} className="anim-imgs" alt="" />
                </div>
                <div className="para">
                  <p>
                    Maximize the capabilities of your retail staff with our
                    advanced online training programs, meticulously crafted to
                    address the unique challenges of the retail industry. In an
                    environment where customer expectations are constantly
                    evolving
                  </p>
                </div>
                <div className="action">
                  <Link to={"/retail"}>
                    Read More{" "}
                    <div class="arrow">
                      <span></span>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
            <div className="domain">
              <div className="domain-img">
                <img src={Construction} alt="" />
              </div>
              <div className="domain-content">
                <div className="sub-heading">
                  <h3>Construction</h3>
                  <img src={Anim5} className="anim-imgs" alt="" />
                </div>
                <div className="para">
                  <p>
                    In the constantly changing landscape of healthcare, it's
                    vital for professionals to remain current with the latest
                    protocols and advancements. Conventional training approaches
                    often prove cumbersome and time-intensive, resulting in gaps
                    in knowledge that can impede patient care.
                  </p>
                </div>
                <div className="action">
                  <Link to={"/construction"}>
                    Read More{" "}
                    <div class="arrow">
                      <span></span>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </OwlCarousel>
          </div>
        
        </div>
        <div className="section products" id="products">
          <div className="heading"  data-aos="fade-up" data-aos-duration="3000">
            <div className="flex">
              <h2>Products</h2>
            </div>
            <p>
              Unleash your potential with wide range of interactive online
              courses, designed to fit every stage of your career.
            </p>
          </div>
          <div className="container-fluid"  data-aos="fade-up" data-aos-duration="3000">
            <div className="row">
              <div className="col-lg-4">
                <div className="product">
                  <div className="product-img">
                    <img src={LMS} alt="" />
                  </div>
                  <div className="overlay"></div>
                  <div className="hover-content">
                    <h4>Learning Management System</h4>
                    <Link to={"/lms"}>Read More</Link>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="product">
                  <div className="product-img">
                    <img src={Examiner} alt="" />
                  </div>
                  <div className="overlay"></div>
                  <div className="hover-content">
                    <h4>The Examiner</h4>
                    <Link to={"/examiner"}>Read More</Link>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="product">
                  <div className="product-img">
                    <img src={CCD} alt="" />
                  </div>
                  <div className="overlay"></div>
                  <div className="hover-content">
                    <h4>Custom Course Development</h4>
                    <Link to={"/customcoursedevelopment"}>Read More</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="section blogs" id="blogs">
        <div className="blogs-circle"></div>
        <div className="blogs-container">
          <div className="heading">
            <div className="heading-flex">
              <h2>Blogs</h2>
              <p>
                We offer a platform for creativity, self-expression, and
                connection with people.
              </p>
            </div>
            <div className="act">
              <Link to={"/blogs"}>View All</Link>
            </div>
          </div>
          {blogs.length > 0 ? (
            <>
              <div className="blogs-flex blogs-flex1">
                <div
                  className="blog blog1"
                  onClick={() => {
                    handleBlogClick(blogs[0]);
                  }}
                   data-aos="fade-down-right" data-aos-duration="1500"
                >
                  <div className="overlay1"></div>
                  <img
                    src={`https://fidusindia.in/cit/assets/blog_images/${blogs[0].image}`}
                    width="200px"
                    alt=""
                    className={`image image-1`}
                  />
                </div>

                <div
                  className="blog blog2"
                  onClick={() => {
                    handleBlogClick(blogs[1]);
                  }}
                  data-aos="fade-down-left" data-aos-duration="1500"
                >
                  <div className="overlay2"></div>
                  <img
                    src={`https://fidusindia.in/cit/assets/blog_images/${blogs[1].image}`}
                    width="200px"
                    alt=""
                    className={`image image-2`}
                  />
                </div>
              </div>
              <div className="blogs-flex blogs-flex2">
                <div
                  className="blog blog3"
                  onClick={() => {
                    handleBlogClick(blogs[2]);
                  }}
                  data-aos="fade-up-right" data-aos-duration="1500"
                >
                  <div className="overlay3"></div>
                  <img
                    src={`https://fidusindia.in/cit/assets/blog_images/${blogs[2].image}`}
                    width="200px"
                    alt=""
                    className={`image image-3`}
                  />
                </div>
                <div
                  className="blog blog4"
                  onClick={() => {
                    handleBlogClick(blogs[3]);
                  }}
                   data-aos="fade-up-left" data-aos-duration="1500"
                >
                  <div className="overlay4"></div>
                  <img
                    src={`https://fidusindia.in/cit/assets/blog_images/${blogs[3].image}`}
                    width="200px"
                    alt=""
                    className={`image image-4`}
                  />
                </div>
              </div>
            </>
          ) : (
            <></>
          )}
        </div>
      </div>
      <div className="section map" id="contact" >
        <div className="heading" data-aos="fade-up" data-aos-duration="1500">
          <h2>Let's Connect</h2>
          <p>
            Let's connect and work together to create something extraordinary.
            By combining our skills and knowledge, we can achieve great things.
          </p>
        </div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-7">
              <div className="map" data-aos="fade-right" data-aos-duration="1500">
                <iframe
                  className="map1"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3782.1211700935796!2d73.90580327423856!3d18.568575167708072!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c131ed5b54a7%3A0xad718b8b2c93d36d!2sSky%20Vista!5e0!3m2!1sen!2sin!4v1714391133225!5m2!1sen!2sin"
                  width="100%"
                  height="400"
                  style={{ border: 0 }}
                  allowfullscreen=""
                  loading="lazy"
                  referrerpolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>
            <div className="col-lg-5">
              <Form
                noValidate
                validated={validated}
                onSubmit={handleSubmit}
                className="contact-form"
                data-aos="fade-left" data-aos-duration="1500"
                // ref={form}
              >
                <div className="form-name">
                  <Form.Group className="contact-form-group mb-3">
                    <Form.Label className="form-label">Name*</Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      placeholder="Enter your name.."
                      value={userDetails.name}
                      onChange={handleChange}
                      required
                      className="input-field abc"
                      validations={[required]}
                    />
                  </Form.Group>

                  <Form.Group className="contact-form-group mb-3">
                    <Form.Label className="form-label">Email*</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      placeholder="Enter your email.."
                      value={userDetails.email}
                      onChange={handleChange}
                      required
                      className="input-field abc"
                      validations={[required]}
                    />
                  </Form.Group>
                </div>
                <Form.Group className="contact-form-group mb-3">
                  <Form.Label className="form-label">Subject*</Form.Label>
                  <Form.Control
                    type="text"
                    name="subject"
                    placeholder="Enter here.."
                    value={userDetails.subject}
                    onChange={handleChange}
                    required
                    className="input-field"
                    validations={[required]}
                  />
                </Form.Group>
                <Form.Group className="contact-form-group mb-3">
                  <Form.Label className="form-label">Message</Form.Label>
                  <Form.Control
                    type="textbox"
                    name="message"
                    placeholder="Enter your message here.."
                    value={userDetails.message}
                    onChange={handleChange}
                    className="input-field"
                    // validations={[required]}
                  />
                </Form.Group>

                <button className="btn submit-btn">Submit</button>
              </Form>
            </div>
          </div>
        </div>
        <div className="contact-details">
          <div className="container-fluid">
            <div className="row"   data-aos="zoom-in"
                data-aos-duration="1500">
              <div className="col-lg-4">
                <div className="contact-details2">
                  <span className="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="43"
                      height="43"
                      viewBox="0 0 58 58"
                    >
                      <g
                        id="Group_7213"
                        data-name="Group 7213"
                        transform="translate(0.2 0.241)"
                      >
                        <g
                          id="Layer_2"
                          data-name="Layer 2"
                          transform="translate(18.407 12.655)"
                        >
                          <g
                            id="Layer_1"
                            data-name="Layer 1"
                            transform="translate(0)"
                          >
                            <path
                              id="Path_220"
                              data-name="Path 220"
                              d="M9.39,32.118c-.623-.063-1.248-.112-1.87-.192A14.545,14.545,0,0,1,2.04,30.345,5.845,5.845,0,0,1,.588,29.173a2.125,2.125,0,0,1-.026-2.89,5.748,5.748,0,0,1,2.38-1.634,16.676,16.676,0,0,1,3.9-1.035c-.1-.13-.168-.234-.246-.335-1.4-1.84-2.83-3.654-4.18-5.527A12.59,12.59,0,0,1,.176,12.63,10.737,10.737,0,0,1,8.6.209C9.026.125,9.462.069,9.893,0h1.573c.689.125,1.389.207,2.063.385A10.686,10.686,0,0,1,21.36,9.7a11.686,11.686,0,0,1-1.929,7.409c-1.229,1.96-2.711,3.741-4.125,5.568-.23.3-.461.591-.72.92.524.1,1.013.191,1.5.3a11,11,0,0,1,3.4,1.255,6.071,6.071,0,0,1,1.288,1.036,2.177,2.177,0,0,1,0,3.087,5.653,5.653,0,0,1-2.021,1.4A16.555,16.555,0,0,1,13.9,31.923c-.622.076-1.246.128-1.87.191ZM10.7,26.632c.075-.091.129-.151.178-.215,1.258-1.647,2.523-3.285,3.764-4.942s2.534-3.3,3.691-5.032a9.975,9.975,0,0,0,1.7-7.241,9.455,9.455,0,1,0-18.1,5.059,17.9,17.9,0,0,0,2.575,4.287c1.876,2.462,3.774,4.91,5.662,7.36.176.233.343.469.531.724Zm0,4.247c.581-.033,1.567-.063,2.547-.151a16.679,16.679,0,0,0,4.495-.99,5.428,5.428,0,0,0,1.964-1.15,1.042,1.042,0,0,0-.011-1.709,5.315,5.315,0,0,0-1.1-.771,13.9,13.9,0,0,0-4.722-1.315.457.457,0,0,0-.346.184c-.737.976-1.463,1.962-2.188,2.947-.425.577-.844.575-1.267,0-.723-.987-1.455-1.968-2.175-2.957a.367.367,0,0,0-.419-.173c-.971.208-1.954.37-2.913.626a6.544,6.544,0,0,0-2.735,1.345c-.755.669-.768,1.316.025,1.939a6.976,6.976,0,0,0,1.647.951,20.256,20.256,0,0,0,7.2,1.225Z"
                              transform="translate(0)"
                              fill="#646262"
                            />
                            <path
                              id="Path_221"
                              data-name="Path 221"
                              d="M84.152,79.466A4.481,4.481,0,1,1,79.665,75,4.481,4.481,0,0,1,84.152,79.466ZM79.67,82.681a3.2,3.2,0,1,0-3.2-3.194A3.2,3.2,0,0,0,79.67,82.681Z"
                              transform="translate(-68.961 -68.775)"
                              fill="#646262"
                            />
                          </g>
                        </g>
                        <g
                          id="Ellipse_5"
                          data-name="Ellipse 5"
                          transform="translate(-0.2 -0.241)"
                          fill="none"
                          stroke="#646262"
                          stroke-width="3"
                        >
                          <circle cx="29" cy="29" r="29" stroke="none" />
                          <circle cx="29" cy="29" r="27.5" fill="none" />
                        </g>
                      </g>
                    </svg>
                  </span>
                  <span className="text">
                    Unit No. 507, Lunkad Sky Vista, Lohegaon, Viman nagar Pune
                    411014.
                  </span>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="contact-details2">
                  <span className="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="43"
                      height="43"
                      viewBox="0 0 58 58"
                    >
                      <g
                        id="Group_7215"
                        data-name="Group 7215"
                        transform="translate(0.2 0.218)"
                      >
                        <g
                          id="Layer_2"
                          data-name="Layer 2"
                          transform="translate(13.806 18.407)"
                        >
                          <g
                            id="Layer_1"
                            data-name="Layer 1"
                            transform="translate(0)"
                          >
                            <path
                              id="Path_222"
                              data-name="Path 222"
                              d="M30.55,20.765a.725.725,0,0,1-.605.238Q15.271,21,.6,21c-.486,0-.6-.111-.6-.6V.6C0,.116.111,0,.6,0Q15.271,0,29.945,0a.718.718,0,0,1,.605.239ZM1.429.786c.064.072.088.1.116.131Q7.773,6.987,14,13.047a1.726,1.726,0,0,0,2.575-.03Q22.77,7,28.952.969A1.513,1.513,0,0,0,29.1.783Zm27.7,19.429-9.948-8.65c-.084.077-.158.141-.229.21-.619.6-1.233,1.214-1.859,1.81a2.507,2.507,0,0,1-3.631,0c-.455-.43-.9-.874-1.345-1.307-.28-.28-.567-.551-.856-.832L1.52,20.215Zm-9.4-9.192,10.035,8.728V1.25ZM.784,19.851,10.71,10.91.784,1.242Z"
                              transform="translate(0)"
                              fill="#646262"
                            />
                          </g>
                        </g>
                        <g
                          id="Ellipse_7"
                          data-name="Ellipse 7"
                          transform="translate(-0.2 -0.218)"
                          fill="none"
                          stroke="#646262"
                          stroke-width="2"
                        >
                          <circle cx="29" cy="29" r="29" stroke="none" />
                          <circle cx="29" cy="29" r="28" fill="none" />
                        </g>
                      </g>
                    </svg>
                  </span>
                  <span className="text">enquiry@fidusindia.in</span>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="contact-details2">
                  <span className="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="43"
                      height="43"
                      viewBox="0 0 58 58"
                    >
                      <g
                        id="Group_7214"
                        data-name="Group 7214"
                        transform="translate(0.2 0.181)"
                      >
                        <g
                          id="Layer_2"
                          data-name="Layer 2"
                          transform="translate(16.107 16.107)"
                        >
                          <g
                            id="Layer_1"
                            data-name="Layer 1"
                            transform="translate(0 0)"
                          >
                            <path
                              id="Path_155"
                              data-name="Path 155"
                              d="M0,5.6A5.562,5.562,0,0,1,1.856,1.543,5.927,5.927,0,0,1,3.752.185,2.236,2.236,0,0,1,6.44.774Q8.121,2.638,9.788,4.512a2.533,2.533,0,0,1-.012,3.263,2.8,2.8,0,0,1-.451.474,1.948,1.948,0,0,0-.691,2.207,3.814,3.814,0,0,0,.49,1.073A15.494,15.494,0,0,0,13.388,16a6.479,6.479,0,0,0,1.488.721,1.91,1.91,0,0,0,2.223-.6,2.709,2.709,0,0,1,3.418-.582,2.257,2.257,0,0,1,.414.3q1.814,1.677,3.62,3.363a2.043,2.043,0,0,1,.519,2.689,6.305,6.305,0,0,1-4.644,3.4,6.967,6.967,0,0,1-3.331-.468,21.921,21.921,0,0,1-5.415-2.95,33.887,33.887,0,0,1-9.263-9.754A15.86,15.86,0,0,1,.281,7.352C.146,6.776.091,6.183,0,5.6Zm19.718,18.85c.323-.038.65-.054.968-.12A5.727,5.727,0,0,0,23.563,22.5a3.994,3.994,0,0,0,.647-.893,1.324,1.324,0,0,0-.307-1.764c-1.189-1.11-2.38-2.223-3.579-3.319a1.689,1.689,0,0,0-.637-.363,1.85,1.85,0,0,0-1.979.65,2.809,2.809,0,0,1-1.66.887,3.659,3.659,0,0,1-2.481-.514,15.522,15.522,0,0,1-4.684-4.371,6.235,6.235,0,0,1-1.065-1.831,2.957,2.957,0,0,1,.935-3.445A1.692,1.692,0,0,0,9.06,5.071Q7.4,3.206,5.728,1.355A1.293,1.293,0,0,0,4.3.952a2.162,2.162,0,0,0-.768.372A17.677,17.677,0,0,0,1.951,2.839a4.2,4.2,0,0,0-.922,3.577,11.409,11.409,0,0,0,1.487,4.041,32.02,32.02,0,0,0,7.723,9.156,27.2,27.2,0,0,0,6.178,4A8.843,8.843,0,0,0,19.717,24.447Z"
                              transform="translate(0 0.029)"
                              fill="#646262"
                            />
                          </g>
                        </g>
                        <g
                          id="Ellipse_6"
                          data-name="Ellipse 6"
                          transform="translate(-0.2 -0.181)"
                          fill="none"
                          stroke="#646262"
                          stroke-width="2"
                        >
                          <circle cx="29" cy="29" r="29" stroke="none" />
                          <circle cx="29" cy="29" r="28" fill="none" />
                        </g>
                      </g>
                    </svg>
                  </span>
                  <span className="text">+91 2048465792</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal show={show2} onHide={handleClose2} centered>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className="thanks-modal">
          <p>Thank You for contacting us!</p>
          <span>We will get in touch with you soon.</span>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => {
              navigate("/");
              handleClose2();
            }}
          >
            Okay
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Home;
